var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h30v30H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.429 24.333A2.775 2.775 0 0 0 9.286 27h11.428a2.775 2.775 0 0 0 2.857-2.667v-16H6.429zM25 4.333h-5L18.571 3h-7.142L10 4.333H5V7h20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDeleted);
export default __webpack_public_path__ + "static/media/status-deleted.f23aa179c90c88315a53e35ee3ed00ea.svg";
export { ForwardRef as ReactComponent };